module.exports = __webpack_public_path__ + "79e272d8c6644e756714018406f54009.svg";